export default {
  baseURL:
    process.env.NODE_ENV === 'development'
      ? `http://localhost:3451/core/api`
      : `${process.env.REACT_APP_API_URL}`,
  timeout: 30000
};
